import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
// import * as config from "config/config"
// import API_CONSTANTS from "constants/constants"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import { ErrorObject, group } from "../../api"
import { CreateGroupRequest, GroupModel, UpdateGroupRequest } from "../../api/group.api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { RootState } from "../../store"
import { createGroup, loadGroups, resetSuccess, updateGroup } from "../../store/group.store"
// import GroupsTable from "components/Groups/GroupsTable"
import Header from "../Layout/Header"
import AddGroupModal from "./AddGroupModal"
import GroupsTable from "./GroupsTable"
// import { parcelHubLogin } from "config/config"

const Groups = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { groups, modulesAndMenus, loading, error, success } = useAppSelector(
        (state: RootState) => state.groups
    )
    const [groupDetails, setGroupDetails] = useState({} as GroupModel)
    const [errors, setErrors] = useState({} as Record<string, any>)

    // const [isNameValid, setIsNameValid] = useState(true)
    const [show, setShow] = useState(false)
    const handleShow = () => {
        setGroupDetails({} as GroupModel)
        setShow(true)
    }

    const findFormErrors = (customError?: Record<string, any>) => {
        let newErrors = {} as Record<string, any>
        if (!customError) {
            if (error?.payload && error?.payload?.length !== 0) {
                error?.payload?.forEach((e: ErrorObject) => (newErrors[e?.param?.split(".")[1]] = e.msg))
            } else if (error?.error && error?.error !== "") {
                newErrors["genericError"] = error.error
            }
        } else {
            newErrors[customError?.param] = customError?.msg
        }
        return newErrors
    }

    const handleSubmit = async (groupDetails: Record<string, any>) => {
        if (groupDetails?.id) {
            await dispatch(updateGroup(groupDetails as UpdateGroupRequest))
        } else {
            await dispatch(createGroup(groupDetails as CreateGroupRequest))
        }
    }

    const checkNameValidity = async (groupName: string) => {
        try {
            await group.validateGroupName(groupName)
        } catch (error: any) {
            const returnedErrors = await findFormErrors({
                msg: error?.response?.data?.data?.code,
                param: "name"
            })
            setErrors(returnedErrors)
        }
    }

    useEffect(() => {
        dispatch(loadGroups())
    }, [])

    useEffect(() => {
        const returnedErrors = findFormErrors()
        setErrors(returnedErrors)
    }, [error?.error, error?.payload?.length])

    useEffect(() => {
        if (success) {
            dispatch(loadGroups())
            setShow(false)
            dispatch(resetSuccess())
        }
    }, [success])

    return (
        <>
            {loading || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="groups-container">
                    <Header
                        title={t("Groups")}
                        records={groups.length}
                        data={groups}
                        name="Groups"
                        //buttonId="#groupsExportButton"
                    >
                        <div className="mx-2">
                            {/*<DateRangePickerCustom setStartDate={setStartDate} setEndDate={setEndDate} />*/}
                        </div>
                    </Header>
                    <div className="row justify-content-end mx-1 mt-3">
                        <Button className="col-1" onClick={handleShow}>
                            {t("Add Group")}
                        </Button>
                    </div>
                    <div className="row d-flex">
                        <GroupsTable
                            groups={groups}
                            groupDetails={groupDetails}
                            setGroupDetails={setGroupDetails}
                            setShow={setShow}
                        />
                    </div>
                    <AddGroupModal
                        show={show}
                        loading={loading}
                        handleSubmit={handleSubmit}
                        groupDetails={groupDetails}
                        setGroupDetails={setGroupDetails}
                        checkNameValidity={checkNameValidity}
                        handleClose={() => setShow(false)}
                        errors={errors}
                        setErrors={setErrors}
                        modulesAndMenus={modulesAndMenus || []}
                    />
                </div>
            )}
        </>
    )
}

export default Groups
